import React, { useState, useEffect } from "react";
import "./NewHiresTable.css";
import apiClient from "../../apiClient";

function NewHiresTable({ selectedMUM, storeData, onNavigateToProfile }) {
  const [newHires, setNewHires] = useState([]);
  const [totalNewHires, setTotalNewHires] = useState(0);

  useEffect(() => {
    if (selectedMUM) {
      const fetchNewHires = async () => {
        try {
          const response = await apiClient.get(
            `/api/current-month-hires?mum=${encodeURIComponent(
              selectedMUM
            )}&ts=${Date.now()}`
          );

          if (response.status === 200) {
            const data = response.data;
            const hiresByStore = data.map((store) => ({
              storeName: store.corp,
              hires: store.employees,
            }));

            setNewHires(hiresByStore);
            setTotalNewHires(
              hiresByStore.reduce(
                (total, store) => total + store.hires.length,
                0
              )
            );
          } else {
            console.error("Failed to fetch new hires:", response.statusText);
          }
        } catch (error) {
          console.error("Error fetching new hires:", error);
        }
      };

      fetchNewHires();
    }
  }, [selectedMUM]);

  const handleEmployeeClick = (userId) => {
    if (userId) {
      onNavigateToProfile(userId);
    }
  };

  return (
    <div className="new-hires-container">
      <div className="new-hires-header">
        <h2>
          New Hires this Month: <span>{totalNewHires}</span>
        </h2>
      </div>
      <div className="new-hires-table">
        <table>
          <thead>
            <tr>
              {storeData.map((store) => (
                <th key={store.corp}>{store.corp}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {newHires.length > 0 &&
              Array.from({
                length: Math.max(
                  ...newHires.map((store) => store.hires.length),
                  0
                ),
              }).map((_, rowIndex) => (
                <tr key={rowIndex}>
                  {storeData.map((store) => {
                    const hire = newHires.find(
                      (s) => s.storeName === store.corp
                    )?.hires[rowIndex];
                    return (
                      <td
                        key={store.corp}
                        onClick={() =>
                          hire ? handleEmployeeClick(hire.user_id) : null
                        }
                        style={{ cursor: hire ? "pointer" : "default" }}
                      >
                        {hire ? (
                          <div className="hire-details">
                            <div className="hire-name">
                              {hire.employee_name} ({hire.position_initials})
                              {hire.is_minor && (
                                <div className="minor-badge">
                                  <span className="minor-icon">👤</span>
                                  <div className="tooltip">Is Minor</div>
                                </div>
                              )}
                            </div>
                            <div className="hire-hire-date">
                              {hire.hire_date || "No Hire Date"}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default NewHiresTable;
